import { createUseStyles } from 'react-jss';

export const useModalStyles = createUseStyles({
  'modal-transition': {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    'scrollbar-width': 'none',
    '-ms-overflow-style': 'none',
    transition: 'all 250ms',
    opacity: 0,
    transform: 'translateY(-10px)',
    '&.modal-transition-enter-active, &.modal-transition-enter-done': {
      opacity: 1,
      transform: 'translateY(0px)',
    },
    '&.modal-transition-leave-active': {
      opacity: 0,
      transform: 'translateY(-10px)',
    },
  },
  'bg-layer-transition': {
    transition: 'opacity 250ms',
    opacity: 0,
    '&.bg-layer-transition-enter-active, &.bg-layer-transition-enter-done': {
      opacity: 0.5,
    },
    '&.bg-layer-transition-leave-active': {
      opacity: 0,
    },
  },
});
